export const printQR = async (qrCode, printTitle) => {
  try {
    // Use PNG instead of SVG for better print compatibility
    const blob = await qrCode.getRawData("png");
    const url = URL.createObjectURL(blob);

    const printWindow = window.open("", "_blank");

    const html = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>${printTitle || "Print QR Code"}</title>
        <style>
          @media print {
            @page {
              size: auto;
              margin: 20mm;
            }
            body {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
          }
          
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          body {
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 100vh;
            padding: 20px;
          }
          
          img {
            width: 600px;
            height: 600px;
            display: block;
            max-width: 100%;
            height: auto;
          }
        </style>
      </head>
      <body>
        <img src="${url}" id="qr-image" />
        <script>
          const img = document.getElementById('qr-image');
          
          // Wait for image to fully load before printing
          img.onload = () => {
            setTimeout(() => {
              window.print();
            }, 250);
          };
          
          // Close window after printing
          window.onafterprint = () => {
            window.close();
            // Clean up the blob URL
            URL.revokeObjectURL('${url}');
          };
          
          // Fallback if image doesn't load
          setTimeout(() => {
            if (!img.complete) {
              console.error('Image failed to load');
              window.close();
            }
          }, 5000);
        </script>
      </body>
      </html>
    `;

    printWindow.document.write(html);
    printWindow.document.close();
  } catch (error) {
    console.error("Error printing QR code:", error);
  }
};
